<div class="content">

    <!-- Begin dashboard -->
    <div class="container-fluid overflow-auto pt-5 mt-4" style="max-height: 860px;">

        <!-- Page Heading -->
        <div class="d-sm-flex align-items-center justify-content-between mb-4">
            <h1 class="h3 mb-0 text-gray-800">Staff Enrollment</h1>
        </div>

        <!-- Content Row -->
        <div class="row">
            <div class="col-xl-12 col-md-12 mb-2">
                <div class="card border-left-primary shadow h-100 py-2">
                    <div class="card-body">
                        <div class="row no-gutters align-items-center">
                            <div class="col mr-2">
                                <div class="text-xs font-weight-bold text-primary  mb-1">
                                    <form *ngIf="providerForm" [formGroup]="providerForm">
                                        <div class="row">
                                            <!-- Staff Type -->
                                            <div class="col-xl-4 col-md-4" >
                                                <div class="form-group ">
                                                    <mat-form-field appearance="outline">
                                                        <mat-label>Staff Type </mat-label>
                                                        <mat-select formControlName="staffType" class="text-primary">
                                                            <mat-option class="text-primary" *ngFor="let type of sType" [value]="type.value">{{type.viewValue}}</mat-option>
                                                        </mat-select>
                                                        <mat-error *ngIf="providerForm.controls.staffType.errors?.required">This field is required ! </mat-error>
                                                    </mat-form-field>
                                                </div>
                                            </div>
                                            <div class="col-xl-4 col-md-4" >
                                                <div class="form-group ">
                                                    <mat-form-field appearance="outline">
                                                        <mat-label>Is User </mat-label>
                                                        <mat-select formControlName="providerIsUser" class="text-primary">
                                                            <mat-option class="text-primary" *ngFor="let type of uType" [value]="type.value">{{type.viewValue}}</mat-option>
                                                        </mat-select>
                                                        <mat-error *ngIf="providerForm.controls.providerIsUser.errors?.required">This field is required ! </mat-error>
                                                    </mat-form-field>
                                                </div>
                                            </div>
                                            <!-- Fields always visible -->
                                            <div class="col-xl-4 col-md-4" >
                                                <div class="form-group ">
                                                    <mat-form-field appearance="outline">
                                                        <mat-label>First Name</mat-label>
                                                        <input matInput formControlName="firstName" placeholder="Provider First Name" >
                                                        <mat-error *ngIf="providerForm.controls.firstName.errors?.required">This field is required ! </mat-error>
                                                    </mat-form-field>
                                                </div>
                                            </div>

                                            <div class="col-xl-4 col-md-4" >
                                                <div class="form-group ">
                                                    <mat-form-field appearance="outline">
                                                        <mat-label>Last Name</mat-label>
                                                        <input matInput formControlName="lastName" placeholder="Provider Last Name" >
                                                        <mat-error *ngIf="providerForm.controls.lastName.errors?.required">This field is required ! </mat-error>
                                                    </mat-form-field>
                                                </div>
                                            </div>
                                               <!--provider Type-->
                                            <div class="col-xl-4 col-md-4" *ngIf="isProviderSelected">
                                                <div class="form-group ">
                                                    <mat-form-field appearance="outline">
                                                        <mat-label>Provider Type </mat-label>
                                                        <mat-select formControlName="type" class="text-primary">
                                                            <mat-option class="text-primary" *ngFor="let type of providerType" [value]="type.value">{{type.viewValue}}</mat-option>
                                                        </mat-select>
                                                        <mat-error *ngIf="providerForm.controls.type.errors?.required">This field is required ! </mat-error>
                                                    </mat-form-field>
                                                </div>
                                            </div>
                                            <div class="col-xl-4 col-md-4" *ngIf="isProviderSelected">
                                                <div class="form-group ">
                                                    <mat-form-field appearance="outline">
                                                        <mat-label>Tax ID</mat-label>
                                                        <input matInput formControlName="taxId"  >
                                                        <mat-error *ngIf="providerForm.controls.taxId.errors?.required">This field is required ! </mat-error>
                                                    </mat-form-field>
                                                </div>
                                            </div>
                                            <div class="col-xl-4 col-md-4" *ngIf="isProviderSelected">
                                                <div class="form-group ">
                                                    <mat-form-field appearance="outline">
                                                        <mat-label>NPI No.</mat-label>
                                                        <input matInput formControlName="npi" placeholder="NPI No." >
                                                        <mat-error *ngIf="providerForm.controls.npi.errors?.required">This field is required ! </mat-error>
                                                    </mat-form-field>
                                                </div>
                                            </div>
                                            <div class="col-xl-4 col-md-4" *ngIf="isProviderSelected">
                                                <div class="form-group ">
                                                    <mat-form-field appearance="outline">
                                                        <mat-label>License Number</mat-label>
                                                        <input matInput formControlName="license"  >
                                                        <mat-error *ngIf="providerForm.controls.license.errors?.required">This field is required ! </mat-error>
                                                    </mat-form-field>
                                                </div>
                                            </div>
                                            <div class="col-xl-4 col-md-4" *ngIf="isProviderSelected">
                                                <div class="form-group ">
                                                    <mat-form-field appearance="outline">
                                                        <mat-label>Degree</mat-label>
                                                        <input matInput formControlName="degree"  >
                                                        <mat-error *ngIf="providerForm.controls.degree.errors?.required">This field is required ! </mat-error>
                                                    </mat-form-field>
                                                </div>
                                            </div>
<!--                                            other staff type-->
                                            <div class="col-xl-4 col-md-4">
                                                <div class="form-group ">
                                                    <mat-form-field appearance="outline">
                                                        <mat-label>Phone Type </mat-label>
                                                        <mat-select formControlName="phoneType" class="text-primary">
                                                            <mat-option class="text-primary" *ngFor="let type of phoneType" [value]="type.value">{{type.viewValue}}</mat-option>
                                                        </mat-select>
                                                        <mat-error *ngIf="providerForm.controls.phoneType.errors?.required">This field is required ! </mat-error>
                                                    </mat-form-field>
                                                </div>
                                            </div>
                                            <div class="col-xl-4 col-md-4">
                                                <div class="form-group ">
                                                    <mat-form-field appearance="outline">
                                                        <mat-label>Provider/Staff Phone Number:</mat-label>
                                                        <input matInput formControlName="number" placeholder="Provider Phone Number:" type="tel" pmPhoneFormat>
                                                        <mat-error *ngIf="providerForm.controls.number.errors?.required">This field is required ! </mat-error>
                                                    </mat-form-field>
                                                </div>
                                            </div>
                                            <div class="col-xl-4 col-md-4">
                                                <div class="form-group">
                                                    <mat-form-field appearance="outline">

                                                        <mat-label>Offices</mat-label>

                                                        <mat-select
                                                            formControlName="officeIds"
                                                            class="text-primary"
                                                            multiple
                                                            (selectionChange)="onOfficeSelectionChange($event)">

                                                            <!-- Select All -->
                                                            <mat-option [value]="SELECT_ALL_OFFICES">
                                                                Select All
                                                            </mat-option>

                                                            <!-- Office List -->
                                                            <mat-option
                                                                class="text-primary"
                                                                *ngFor="let office of OfficeType"
                                                                [value]="office.id">

                                                                {{ office.name }}

                                                            </mat-option>

                                                        </mat-select>

                                                        <mat-error
                                                            *ngIf="providerForm.controls.officeIds.errors?.required">
                                                            This field is required !
                                                        </mat-error>

                                                    </mat-form-field>
                                                </div>
                                            </div>
                                            <div class="col-xl-4 col-md-4">
                                                <div class="form-group ">
                                                    <mat-form-field appearance="outline">
                                                        <mat-label>Email</mat-label>
                                                        <input matInput formControlName="email"  >
                                                        <mat-error *ngIf="providerForm.controls.email.errors?.required">This field is required ! </mat-error>
                                                        <mat-error *ngIf="providerForm.controls.email.errors?.email">Require valid email format ! </mat-error>
                                                    </mat-form-field>
                                                </div>
                                            </div>

                                            <div class="col-xl-4 col-md-4">
                                                <div class="form-group ">
                                                    <mat-form-field appearance="outline">
                                                        <mat-label>Salutation</mat-label>
                                                        <input matInput formControlName="salutation"  >
                                                        <mat-error *ngIf="providerForm.controls.salutation.errors?.required">This field is required ! </mat-error>
                                                    </mat-form-field>
                                                </div>
                                            </div>

                                            <div class="col-xl-4 col-md-4">
                                                <div class="form-group ">
                                                    <mat-form-field appearance="outline">
                                                        <mat-label>Address</mat-label>
                                                        <input matInput formControlName="firstLine" placeholder="First Line">
                                                        <mat-error *ngIf="providerForm.controls.firstLine.errors?.required">This field is required ! </mat-error>
                                                    </mat-form-field>
                                                </div>
                                            </div>

                                            <div class="col-xl-4 col-md-4">
                                                <div class="form-group ">
                                                    <mat-form-field appearance="outline">
                                                        <mat-label>Second Line</mat-label>
                                                        <input matInput formControlName="secondLine" >
                                                        <mat-error *ngIf="providerForm.controls.secondLine.errors?.required">This field is required ! </mat-error>
                                                    </mat-form-field>
                                                </div>
                                            </div>

                                            <div class="col-xl-4 col-md-4">
                                                <div class="form-group ">
                                                    <mat-form-field appearance="outline">
                                                        <mat-label>City</mat-label>
                                                        <input matInput formControlName="city" >
                                                        <mat-error *ngIf="providerForm.controls.city.errors?.required">This field is required ! </mat-error>
                                                    </mat-form-field>
                                                </div>
                                            </div>
                                            <div class="col-xl-4 col-md-4">
                                                <div class="form-group ">
                                                    <mat-form-field appearance="outline">
                                                        <mat-label>State</mat-label>
                                                        <mat-select formControlName="state" class="text-primary">
                                                            <mat-option class="text-primary" *ngFor="let type of stateList" [value]="type.value">{{type.label}}</mat-option>
                                                        </mat-select>
                                                        <mat-error *ngIf="providerForm.controls.state.errors?.required">This field is required ! </mat-error>
                                                    </mat-form-field>
                                                </div>
                                            </div>
                                            <!--<div class="col-xl-4 col-md-4">
                                                <div class="form-group ">
                                                    <mat-form-field appearance="outline">
                                                        <mat-label>State</mat-label>
                                                        <input matInput formControlName="state" >
                                                        <mat-error *ngIf="providerForm.controls.state.errors?.required">This field is required ! </mat-error>
                                                    </mat-form-field>
                                                </div>
                                            </div>-->

                                            <div class="col-xl-4 col-md-4">
                                                <div class="form-group ">
                                                    <mat-form-field appearance="outline">
                                                        <mat-label>Zip</mat-label>
                                                        <input matInput formControlName="zip" pmZipCode >
                                                        <mat-error *ngIf="providerForm.controls.zip.errors?.required">This field is required ! </mat-error>
                                                    </mat-form-field>
                                                </div>
                                            </div>

                                            <div *ngIf="id" class="col-xl-1 col-md-6 mt-3 pt-2" >
                                                <div [ngClass]="status ? 'active' : 'inactive'"><span class="text-primary">Status :</span> {{status ? 'Active' : 'Inactive'}}
                                                    <label class="switch">
                                                        <input type="checkbox" class="success" [checked]="this.status" (click)="changeStatus(this.status)">
                                                        <span class="slider round"></span>
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                        <button type="button" routerLink="/provider"
                                                class="btn btn-secondary float-end  waves-effect waves-light">Cancel</button>
                                        <!-- Register/Update Provider Buttons -->
                                        <button *ngIf="isProviderSelected && !id" class="btn btn-outline-light btn-lg px-5 float-right" mat-raised-button color="primary" type="submit"
                                                (click)="onRegister()" >Register Provider
                                        </button>
                                        <button *ngIf="isProviderSelected && id" class="btn btn-outline-light btn-lg px-5 float-right" mat-raised-button color="primary" type="submit"
                                                (click)="onRegister()" >Update Provider
                                        </button>
                                        <!-- Register/Update Staff Buttons -->
                                        <button
                                                *ngIf="!isProviderSelected && !id"
                                                class="btn btn-outline-light btn-lg px-5 float-right"
                                                mat-raised-button
                                                color="primary"
                                                type="submit"
                                                (click)="onStaffRegister()"
                                        >
                                            Register Staff
                                        </button>
                                        <button
                                                *ngIf="!isProviderSelected && id"
                                                class="btn btn-outline-light btn-lg px-5 float-right"
                                                mat-raised-button
                                                color="primary"
                                                type="submit"
                                                (click)="onStaffRegister()"
                                        >
                                            Update Staff
                                        </button>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>